import React, { useState } from 'react';
import PropTypes from 'prop-types';
import OptionTileModal from '../../../assignments/pages/AssignmentsAndActivities/Components/modals/OptionTileModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';    
import { faPlus, faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import ActivityTypes from '../../../../enums/activityTypes';

const AddQuestionsToAssignment = ({ openOptionTileModal, setOpenOptionTileModal, saveComponentCreate, saveComponentAddToExisting, activityType = ActivityTypes.Assignment }) => {
  const [saveComponent, setSaveComponent] = useState(saveComponentAddToExisting);
  const [saveOptions, setSaveOptions] = useState([
    {
      id: 'addToExisting',
      icon: <FontAwesomeIcon icon={faLayerGroup} className="printing-icon" />,
      label: `Add to Existing ${activityType == ActivityTypes.Assignment ? 'Assignment' : 'Flashcard'}`,
      isActive: true
    },
    {
      id: 'createNew',
      icon: <FontAwesomeIcon icon={faPlus} className="printing-icon" />,
      label: `Create a New ${activityType == ActivityTypes.Assignment ? 'Assignment' : 'Flashcard'}`,
      isActive: false
    }
  ]);

  const handleOptionTileClick = (e) => {
    const id = e.currentTarget.id;
    const option = saveOptions.map((item) =>
      item.id === id ? { ...item, isActive: true } : { ...item, isActive: false }
    );
    setSaveOptions(option);

    if (id === 'createNew') {
      setSaveComponent(saveComponentCreate);
    } else {
      setSaveComponent(saveComponentAddToExisting);
    }
  };

  return (
    <>
      <OptionTileModal
        key={new Date().getTime().toString()}
        isOpen={openOptionTileModal}
        onClose={() => setOpenOptionTileModal(false)}
        title={`Select Or Create ${activityType == ActivityTypes.Assignment ? 'Assignment' : 'Flashcard'}`}
        options={saveOptions}
        handleOptionClick={handleOptionTileClick}
        saveLabel={'Save'}
        additionalComponent={saveComponent}
      />
    </>
  );
};

AddQuestionsToAssignment.propTypes = {
  openOptionTileModal: PropTypes.bool,
  setOpenOptionTileModal: PropTypes.func,
  saveComponentCreate: PropTypes.object,
  saveComponentAddToExisting: PropTypes.object,
  activityType: PropTypes.number
};

export default AddQuestionsToAssignment;
